import React from 'react';
import './banner.css';
import slide1 from '../assets/images/SLIDE1.webp';
import slide2 from '../assets/images/SLIDE2.webp';
import slide3 from '../assets/images/SLIDE3.webp';

const Banner = () => {
  const slides = [slide1, slide2, slide3];

  return (
    <div
      id="homeCarousel"
      className="carousel slide banner-carousel"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-indicators">
        {slides.map((_, idx) => (
          <button
            key={idx}
            type="button"
            data-bs-target="#homeCarousel"
            data-bs-slide-to={idx}
            className={idx === 0 ? 'active' : ''}
            aria-current={idx === 0 ? 'true' : undefined}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>

      <div className="carousel-inner">
        {slides.map((src, idx) => (
          <div
            key={idx}
            className={`carousel-item${idx === 0 ? ' active' : ''}`}
          >
            <img
              src={src}
              alt={`Slide ${idx + 1}`}
              className="banner-img d-block w-100"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev custom-control"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="prev"
      >
        <span
          className="carousel-control-prev-icon custom-icon"
          aria-hidden="true"
        />
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next custom-control"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="next"
      >
        <span
          className="carousel-control-next-icon custom-icon"
          aria-hidden="true"
        />
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Banner;
